import { compact } from '.';
import type { ArrayFilter } from './types';

export const limit =
  <T>(count: number): ArrayFilter<T> =>
  (_, index) =>
    index < count;

/**
 * @param d array of input data
 * @returns a `compact` of the array or `undefined` if the array has no values
 */
export const valsOrNone = <T>(
  d?: Array<T | undefined> | undefined,
): Array<T> | undefined => {
  if (!d) {
    return undefined;
  }

  const comp = compact(d);

  if (comp.length > 0) {
    return comp;
  }

  return undefined;
};

export const getArray = <T>(item: T | T[]): T[] =>
  Array.isArray(item) ? item : [item];
